export const duplicator = <T>(item: T, times: number = 5): T[] =>
	Array.from(Array(times)).map(() => item);
